import { config } from '@uhg-abyss/web/tools/config';

export const getDomain = (product, port) => {
  const appEnv = config('APP_ENV');
  const isBrowser = typeof document !== 'undefined';

  const origin = isBrowser
    ? document.location.origin
    : process.env.PUBLIC_ORIGIN || 'http://localhost';
  if (appEnv === 'prod') {
    return `${origin}/${product}`;
  }
  return appEnv === 'dev' || appEnv === 'local'
    ? `http://localhost:${port}/env/dev`
    : `${origin}/${product}/${appEnv}`;
};
